import { LegalLayout, LegalSection } from "./LegalLayout";

export default function TermsPage() {
  return (
    <LegalLayout title="Terms of service" updated="9 September 2026">
      <LegalSection heading="Agreement">
        <p>
          These terms govern your use of Atlas. By creating an account, you agree to them. Atlas
          is operated from the United Kingdom and these terms are governed by the laws of
          England and Wales.
        </p>
      </LegalSection>

      <LegalSection heading="What Atlas is">
        <p>
          Atlas is a lifetime exploration record: it imports activity history you've already
          logged elsewhere and matches it against curated peaks, trails, landmarks and regions
          to build collections, achievements and an Outdoor Score. Atlas does not plan routes,
          provide navigation, or record activities live — it works with data you already have.
        </p>
      </LegalSection>

      <LegalSection heading="Your account">
        <p>
          You're responsible for keeping your login details secure and for activity on your
          account. You must be at least 16 years old to use Atlas. One account per person.
        </p>
      </LegalSection>

      <LegalSection heading="Plans and billing">
        <p>
          Atlas offers a free plan and a paid Pro subscription, billed monthly or annually in
          GBP, plus an optional one-off Supporters bundle. Subscriptions renew automatically
          until cancelled. You can cancel anytime from Plan &amp; billing — cancelling stops
          future renewals, but you keep Pro access until the end of the period you've already
          paid for. When Pro access lapses, your account reverts to the free plan; nothing
          you've collected — peaks, trails, achievements, your Outdoor Score — is ever deleted
          or reduced.
        </p>
        <p>
          Payments are processed by Stripe. Refunds are considered on a case-by-case basis where
          required by UK consumer law (for example, faulty service) — contact{" "}
          <a href="mailto:hello@goatlas.co.uk" style={{ color: "var(--text-accent)" }}>hello@goatlas.co.uk</a>{" "}
          and we'll sort it out. Subscription payments are otherwise non-refundable for time
          already used.
        </p>
      </LegalSection>

      <LegalSection heading="Acceptable use">
        <p>
          Don't misuse Atlas: no scraping, no attempting to access other users' data, no
          uploading activity data you don't have the right to use, and no abusive or harassing
          behaviour toward other explorers (see the community guidelines). We may suspend or
          terminate accounts that break these terms.
        </p>
      </LegalSection>

      <LegalSection heading="Your content">
        <p>
          You keep ownership of the activity data, posts and comments you upload or create. By
          posting publicly, you allow other users to view it and Atlas to display it as part of
          the service (for example, on a public profile or a shared trophy card). You can delete
          your own content at any time.
        </p>
      </LegalSection>

      <LegalSection heading="Service availability">
        <p>
          We aim to keep Atlas available and accurate, but we don't guarantee uninterrupted
          service, and the matching pipeline (which pairs your activities against peaks, trails
          and landmarks) is provided as-is — occasional misses or corrections can happen.
        </p>
      </LegalSection>

      <LegalSection heading="Third-party services">
        <p>
          Atlas connects to services you already use, such as Strava, Apple Health, Health Connect
          and Stripe, under those providers' own terms. Those providers are not party to these terms
          and give no warranty to you through Atlas. To the fullest extent permitted by law, all
          warranties on behalf of third-party service providers, including implied warranties of
          merchantability, fitness for a particular purpose and non-infringement, are disclaimed,
          and no third-party provider is liable to you for any consequential, special, punitive or
          indirect damages arising from your use of Atlas. Your rights under UK consumer law are
          not affected.
        </p>
        <p>
          Strava data is subject to Strava's API terms. If Strava withdraws Atlas's access, we
          will tell you and delete the data we imported from Strava.
        </p>
      </LegalSection>

      <LegalSection heading="Changes">
        <p>
          We may update these terms as Atlas evolves. We'll update the date at the top of this
          page when we do, and material changes will be flagged in-product.
        </p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>
          Questions about these terms: <a href="mailto:hello@goatlas.co.uk" style={{ color: "var(--text-accent)" }}>hello@goatlas.co.uk</a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
